import moment from "moment-mini";

/** Translation key for US upcoming (Intrinio) planned report dates. */
export const REPORT_DATE_PLANNED_DISCLAIMER_KEY =
  "report_date_planned_may_change";

/**
 * US upcoming from Intrinio: confirmation_status === false.
 * null / missing / true → no planned disclaimer (PL legacy or settled US).
 */
export function shouldShowReportDatePlannedDisclaimer(confirmationStatus) {
  return confirmationStatus === false;
}

/**
 * Build financial-report marker tooltip text.
 * confirmation_status false → append planned/may-change disclaimer.
 */
export function formatFinancialReportMarkerLabel(report, translate) {
  const baseLabel = translate(
    `%{report_date} %{report_year} report_type_${report.type}`,
    {
      report_date: moment(report.report_date).format("DD.MM.YYYY"),
      report_year: report.year
    }
  );

  if (!shouldShowReportDatePlannedDisclaimer(report?.confirmation_status)) {
    return baseLabel;
  }

  return `${baseLabel} (${translate(REPORT_DATE_PLANNED_DISCLAIMER_KEY)})`;
}
